<template>
    <v-dialog v-model="is_visible"
              fullscreen hide-overlay
              transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close_function">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Navigation Settings</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="close_function">Close Settings</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-list three-line subheader>
                <v-subheader>
                    Title
                </v-subheader>
            </v-list>

            <v-card-text>
                <v-text-field
                        v-model="item.value"
                        label="Title"
                ></v-text-field>
            </v-card-text>

            <v-list three-line subheader>
                <v-subheader>
                    Color
                </v-subheader>
            </v-list>

            <blocks-functions-color-picker-exact
            :item="item"
            :ikey="'text_color'"
            >

            </blocks-functions-color-picker-exact>

            <v-list three-line subheader>
                <v-subheader>
                    Menu Items
                </v-subheader>
            </v-list>

            <v-card-text>
                <v-list three-line subheader>
                    <v-list-item>
                        <v-btn
                                text
                              color="blue-grey darken-4"
                              @click="item.items.push({'icon': '', 'text': 'New List Item', 'href':'#'})"
                            >
                              <v-icon>
                                mdi-plus
                              </v-icon> Add List Item
                            </v-btn>
                    </v-list-item>
                    <v-list-item v-for="list_item in item.items">
                        <v-text-field
                              v-model="list_item.text"
                              label="Value"
                            ></v-text-field>
                        <v-text-field
                                v-model="list_item.href"
                                label="href"
                        ></v-text-field>
                    </v-list-item>
                </v-list>
            </v-card-text>



        </v-card>
    </v-dialog>
</template>

<script>
  import BlocksFunctionsColorPickerExact from "@/components/Blocks/Functions/ColorPickerExact.vue";
    export default {
        components: {BlocksFunctionsColorPickerExact},
        props: {
            is_visible: Boolean,
            close_function: Function,
            item: Object
        },
        data() {
            return {
                //
            }
        }
    }
</script>
